import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Container } from 'react-bootstrap';

const stickyHeaderStyle = {
  position: 'sticky',
  top: 0,
  backgroundColor: 'var(--bs-body-bg, #fff)',
  zIndex: 1,
};

function Table({ headers = [], minCellWidth, tableContent, stickyHeader }) {
  // const [tableHeight, setTableHeight] = useState('auto');
  const [colSelectedForResizeIdx, setColSelectedForResizeIdx] = useState(null);

  const tableElement = useRef(null);
  const columnRefs = useRef(headers.map(() => React.createRef()));

  useEffect(() => {
    columnRefs.current = headers.map(() => React.createRef());
  }, [headers]);

  const handleColumnResize = useCallback(
    (e) => {
      if (
        colSelectedForResizeIdx === null ||
        !columnRefs.current[colSelectedForResizeIdx]
      )
        return;

      const gridColumns = headers.map((_, i) => {
        const columnRef = columnRefs.current[i]?.current;

        if (i === colSelectedForResizeIdx && columnRef) {
          const width = e.clientX - columnRef.getBoundingClientRect().left;

          if (width >= minCellWidth) {
            return `${width}px`;
          }
        }

        return columnRef ? `${columnRef.offsetWidth}px` : 'auto';
      });

      tableElement.current.style.gridTemplateColumns = `${gridColumns.join(' ')}`;
    },
    [colSelectedForResizeIdx, headers, minCellWidth],
  );

  const cleanupResizeListeners = useCallback(() => {
    window.removeEventListener('mousemove', handleColumnResize);
    window.removeEventListener('mouseup', endColumnResize);
  }, [handleColumnResize]);

  const endColumnResize = useCallback(() => {
    setColSelectedForResizeIdx(null);
    cleanupResizeListeners();
  }, [cleanupResizeListeners]);

  useEffect(() => {
    if (colSelectedForResizeIdx !== null) {
      window.addEventListener('mousemove', handleColumnResize);
      window.addEventListener('mouseup', endColumnResize);
    }

    return () => {
      cleanupResizeListeners();
    };
  }, [
    colSelectedForResizeIdx,
    handleColumnResize,
    endColumnResize,
    cleanupResizeListeners,
  ]);

  return (
    <Container fluid className="m-0 px-0">
      <table
        className="custom-vehicle-tracking-table"
        style={{
          gridTemplateColumns: `repeat(${headers.length}, minmax(100px, 1fr))`,
        }}
        ref={tableElement}
      >
        <thead className="table-head-container">
          <tr>
            {headers.map((headerObj, idx) => (
              <th
                className="table-header"
                ref={columnRefs.current[idx]}
                key={`header-${headerObj.label}`}
                style={stickyHeader ? stickyHeaderStyle : undefined}
              >
                <div className="div-flex-row cg-10 div-align-center">
                  {idx === 0 ? (
                    <span className="text-sm text-semi-bold text-grey">
                      {headerObj.label}
                    </span>
                  ) : (
                    <span className="text-sm text-semi-bold text-grey">
                      {headerObj.label}
                    </span>
                  )}
                </div>
                <button
                  style={{ height: '60%', top: '20%' }}
                  onMouseDown={() => setColSelectedForResizeIdx(idx)}
                  className={`resize-handle ${
                    colSelectedForResizeIdx === idx ? 'active' : 'idle'
                  }`}
                  aria-label={`Resize column ${headerObj.label}`}
                />
              </th>
            ))}
          </tr>
        </thead>
        {tableContent}
      </table>
    </Container>
  );
}

export default Table;
